import Vue from 'vue';
import VueRouter from "vue-router";

// Pages
import NotFound from "@/vue/pages/NotFound";
import Home from "@/vue/pages/Home";
import Projects from "@/vue/pages/Projects";
import Contact from "@/vue/pages/Contact";
import Experience from "@/vue/pages/Experience";
import Apps from '@/vue/pages/Apps';

import Nations from '@/vue/pages/apps/Nations';
import Feast from '@/vue/pages/apps/Feast';
import Dyson from '@/vue/pages/apps/Dyson';
import Cryptid from '@/vue/pages/apps/Cryptid';

Vue.use(VueRouter);

const routes = [
    {
        path: '*',
        name: 'not-found',
        component: NotFound,
        meta: {
            title: "Not found"
        }
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: "Portfolio"
        }
    },
    {
        path: '/projects',
        name: 'projects',
        component: Projects,
        meta: {
            title: "Projects"
        }
    },
    {
        path: '/experience',
        name: 'experience',
        component: Experience,
        meta: {
            title: "Experience"
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact,
        meta: {
            title: "Contact"
        }
    },
    {
        path: '/apps',
        name: 'apps',
        component: Apps,
        children: [
            {
                path: 'nations-app',
                name: 'nations-app',
                component: Nations,
                meta: {
                    title: "Nations randomizer"
                }
            },
            {
                path: 'feast-app',
                name: 'feast-app',
                component: Feast,
                meta: {
                    title: "Feast helper"
                }
            },
            {
                path: 'dyson-app',
                name: 'dyson-app',
                component: Dyson,
                meta: {
                    title: "Dyson Sphere"
                }
            },
            {
                path: 'cryptid-app',
                name: 'cryptid-app',
                component: Cryptid,
                meta: {
                    title: "Cryptid Solver"
                }
            },
        ]
    }
];

const router = new VueRouter({
    routes,
    mode: 'history'
});


router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    
    // Find the nearest route element with meta tags.
    // const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    // Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    // if(!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    // nearestWithMeta.meta.metaTags.map(tagDef => {
    //     const tag = document.createElement('meta');

    //     Object.keys(tagDef).forEach(key => {
    //         tag.setAttribute(key, tagDef[key]);
    //     });

    //     // We use this to track which meta tags we create, so we don't interfere with other ones.
    //     tag.setAttribute('data-vue-router-controlled', '');

    //     return tag;
    // })
    // Add the meta tags to the document head.
    // .forEach(tag => document.head.appendChild(tag));

    next();
});

export default router;
